import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { formatValueInBrazilianCurrency } from 'utils';

function CardInfo({
  title, value = 0, valueColor = '#FA461C', loading = false, ...rest
}) {
  return (
    <Box
      display="flex"
      flexWrap="wrap"
      justifyContent="center"
      borderRadius={4}
      width="100%"
      height={83}
      bgcolor="white"
      boxShadow="0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)"
      {...rest}
    >
      <Box p={2} textAlign="center">
        {loading ? <CircularProgress /> : (
          <>
            <Typography letterSpacing={0.5} fontSize={12}>{title}</Typography>
            <Typography fontSize={22} color={valueColor} fontWeight={400}>{formatValueInBrazilianCurrency(value)}</Typography>
          </>
        )}
      </Box>
    </Box>
  );
}

export default CardInfo;
